/**
 *  @module 部分私有属性单独处理
 */

const polyLineType = {
  type: [
    "ScanLine",
    "CircleWave",
    "RadarLine",
    "RadarWave",
    "LineBloom",
    "LineTrail",
    "LineFlicker",
    "PolylineGlow",
    "ODLine",
    "LineFlow",
    "PolylineArrow",
    "PolylineDash",
    "Color",
    "PolylineOutline",
  ],
  key: [
    "color",
    "outlineColor",
    "outlineWidth",
    "gapColor",
    "dashLength",
    "text",
    "bidirectional",
    "speed",
    "bgColor",
    "taperPower",
    "glowPower",
    "glow",
    "gradient",
    "count",
    "polylineOutlineColor",
    "polylineOutlineWidth",
    "repeat_x",
    "ohterLineColor",
  ],
};
const ellipsoidMaterialAttribute = [
  "color",
  "cellAlpha",
  "lineCount",
  "lineThickness",
  "ellipsoidSpeed",
];

// 处理线对应属性时修改
export const changePolyLine = (type, key, graphic, form) => {
  // 燕尾箭头不处理
  if (graphic.type === "fineArrowYW" || graphic.type === "ellipsoid") return;
  const value = polyLineType.type.find((item) => item === type);
  const keyValue = polyLineType.key.find((item) => item === key);
  if (value && keyValue) {
    if (keyValue === "text") {
      graphic.setStyle({
        label: { [key]: form[key] },
      });
    } else {
      if (key === "polylineOutlineColor") {
        graphic.setStyle({
          materialOptions: { ["outlineColor"]: form[key] },
        });
      } else if (key === "polylineOutlineWidth") {
        graphic.setStyle({
          materialOptions: { ["outlineWidth"]: form[key] },
        });
      } else {
        graphic.setStyle({
          materialOptions: { [key]: form[key] },
        });
      }
    }
    return true;
  }
};
// 处理线材质时修改
export const changePolyLineMaterial = (type, key, graphic, form) => {
  if (form[key] === "Color") {
    graphic.setStyle({
      materialType: mars3d.MaterialType.Color,
      materialOptions: {
        color: form["color"],
        materialType: "Color",
      },
    });
  }
  if (form[key] === "PolylineDash") {
    graphic.setStyle({
      materialType: mars3d.MaterialType.PolylineDash,
      materialOptions: {
        color: form["color"],
        dashLength: form["dashLength"] ? form["dashLength"] : 20,
        materialType: "PolylineDash",
        gapColor: form["gapColor"] ? form["gapColor"] : "rgba(255,255,255,0)",
      },
    });
  }
  if (form[key] === "PolylineOutline") {
    graphic.setStyle({
      materialType: mars3d.MaterialType.PolylineOutline,
      materialOptions: {
        color: form["color"],
        materialType: "PolylineOutline",
        outlineColor: form["polylineOutlineColor"],
        outlineWidth: form["polylineOutlineWidth"],
      },
    });
  }
  if (form[key] === "PolylineArrow") {
    graphic.setStyle({
      materialType: mars3d.MaterialType.PolylineArrow,
      materialOptions: {
        color: form["color"],
        materialType: "PolylineArrow",
      },
    });
  }
  if (form[key] === "PolylineGlow") {
    graphic.setStyle({
      materialType: mars3d.MaterialType.PolylineGlow,
      materialOptions: {
        color: form["color"],
        glowPower: form["glowPower"],
        materialType: "PolylineGlow",
      },
    });
  }
  if (form[key] === "ODLine") {
    graphic.setStyle({
      materialType: mars3d.MaterialType.ODLine,
      materialOptions: {
        bgColor: form["bgColor"],
        bidirectional: form["bidirectional"],
        color: form["color"],
        glowPower: form["glowPower"],
        materialType: "ODLine",
        speed: form["speed"],
      },
    });
  }
  if (form[key] === "LineFlicker") {
    graphic.setStyle({
      materialType: mars3d.MaterialType.LineFlicker,
      materialOptions: {
        color: form["color"],
        materialType: "LineFlicker",
        speed: form["speed"],
      },
    });
  }
  if (form[key] === "LineTrail") {
    graphic.setStyle({
      materialType: mars3d.MaterialType.LineTrail,
      materialOptions: {
        color: form["color"],
        materialType: "LineTrail",
        speed: form["speed"],
      },
    });
  }
  if (form[key] === "LineBloom") {
    graphic.setStyle({
      materialType: mars3d.MaterialType.LineBloom,
      materialOptions: {
        color: form["color"],
        glow: form["glow"],
        materialType: "LineBloom",
        speed: form["speed"],
      },
    });
  }
  if (form[key] === "dynamicArrowCoarse") {
    graphic.setStyle({
      materialType: mars3d.MaterialType.LineFlow,
      materialOptions: {
        color: form["color"],
        image: "/img/textures/lineArrow2.png",
        speed: form["speed"],
        repeat_x: 10,
        tag: "dynamicArrowCoarse",
      },
    });
  }
  if (form[key] === "dynamicArrowFine") {
    graphic.setStyle({
      materialType: mars3d.MaterialType.LineFlow,
      materialOptions: {
        color: form["color"],
        image: "/img/textures/lineAarrow.png",
        speed: form["speed"],
        repeat_x: 10,
        tag: "dynamicArrowFine",
      },
    });
  }
  if (form[key] === "flowLine") {
    graphic.setStyle({
      materialType: mars3d.MaterialType.LineFlow,
      materialOptions: {
        color: form["color"],
        image: "/img/textures/LinkPulse.png",
        speed: form["speed"],
        repeat_x: 10,
        tag: "flowLine",
      },
    });
  }
};
// 处理面属性时修改
export const changePolygon = (type, key, graphic, form) => {
  if (type === "circle") {
    switch (key) {
      case "surfaceFillColor":
        graphic.setStyle({
          materialOptions: {
            color: form[key],
          },
        });
        break;
      default:
        graphic.setStyle({
          materialOptions: {
            [key]: form[key],
          },
        });
    }
  }
  switch (key) {
    case "surfaceFillON":
      graphic.setStyle({
        fill: form[key],
      });
      break;
    case "surfaceFillColor":
      graphic.setStyle({
        color: form[key],
      });
      break;
    case "surfaceOutLine":
      graphic.setStyle({
        outline: form[key],
      });
      break;
    case "surfaceOutLineColor":
      graphic.setStyle({
        outlineColor: form[key],
      });
      break;
    case "surfaceOutLineWidth":
      graphic.setStyle({
        outlineWidth: form[key],
      });
      break;
    default:
      graphic.setStyle({
        [key]: form[key],
      });
  }
};
// 处理面填充材质时修改
export const changeFillMaterial = (type, key, graphic, form) => {
  if (form[key] === "Color") {
    graphic.setStyle({
      materialType: mars3d.MaterialType.Color,
      materialOptions: {
        color: form["surfaceFillColor"],
        materialType: "Color",
      },
    });
  }
  if (form[key] === "ScanLine") {
    graphic.setStyle({
      materialType: mars3d.MaterialType.ScanLine,
      materialOptions: {
        color: form["surfaceFillColor"],
        materialType: "ScanLine",
        speed: form["speed"],
      },
    });
  }
  if (form[key] === "CircleWave") {
    graphic.setStyle({
      materialType: mars3d.MaterialType.CircleWave,
      materialOptions: {
        color: form["surfaceFillColor"],
        materialType: "CircleWave",
        speed: form["speed"],
        count: form["count"],
        gradient: form["gradient"],
      },
    });
  }
  if (form[key] === "RadarLine") {
    graphic.setStyle({
      materialType: mars3d.MaterialType.RadarLine,
      materialOptions: {
        color: form["surfaceFillColor"],
        materialType: "RadarLine",
        speed: form["speed"],
      },
    });
  }
  if (form[key] === "RadarWave") {
    graphic.setStyle({
      materialType: mars3d.MaterialType.RadarWave,
      materialOptions: {
        color: form["surfaceFillColor"],
        materialType: "RadarWave",
        speed: form["speed"],
      },
    });
  }
};
// 处理半球填充材质时修改
export const changeEllipsoidMaterial = (type, key, graphic, form) => {
  if (form[key] === "Color") {
    graphic.setStyle({
      materialType: mars3d.MaterialType.Color,
      materialOptions: {
        color: form["color"],
        materialType: "Color",
      },
    });
  }
  if (form[key] === "Grid") {
    graphic.setStyle({
      materialType: mars3d.MaterialType.Grid,
      materialOptions: {
        color: form["color"],
        materialType: "Grid",
        cellAlpha: form["cellAlpha"],
        lineCount: form["lineCount"],
        lineThickness: form["lineThickness"],
      },
    });
  }
  if (form[key] === "EllipsoidWave") {
    graphic.setStyle({
      materialType: mars3d.MaterialType.EllipsoidWave,
      materialOptions: {
        color: form["color"],
        materialType: "EllipsoidWave",
      },
    });
  }
  if (form[key] === "EllipsoidElectric") {
    graphic.setStyle({
      materialType: mars3d.MaterialType.EllipsoidElectric,
      materialOptions: {
        color: form["color"],
        materialType: "EllipsoidElectric",
      },
    });
  }
};
// 处理半球属性修改
export const changeEllipsoid = (type, key, graphic, form) => {
  if (type === "ellipsoid") {
    const data = ellipsoidMaterialAttribute.find((item) => item === key);
    if (data) {
      if (data === "ellipsoidSpeed") {
        graphic.setStyle({
          materialOptions: {
            speed: form[data],
          },
        });
      } else {
        graphic.setStyle({
          materialOptions: {
            [data]: form[data],
          },
        });
      }
      return true;
    }
  }
};
